import { useEffect, useState } from "react";
import { get, ref as dbRef } from "firebase/database";
import { rtdb } from "../../firebase.config";

const usePublicProperties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const snapshot = await get(dbRef(rtdb, "properties"));
        if (snapshot.exists()) {
          const raw = snapshot.val();
          const all = [];

          Object.entries(raw).forEach(([landlordId, propsObj]) => {
            Object.entries(propsObj).forEach(([unitId, unitData]) => {
              if (unitData.status === "Listed") {
                all.push({ ...unitData, id: unitId, landlordId });
              }
            });
          });

          setProperties(all);
        }
      } catch (err) {
        console.error("Failed to fetch public properties:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  return { properties, loading };
};

export default usePublicProperties;
